<template>
  <div>
    <div class="text-right">
      <base-button @click="doExport" type="primary" size="md" class="btn-fill text-right">
        Export List
      </base-button>
    </div>
    <div class="full-overlay d-flex" v-if="exporting">
      <div class="mx-auto mt-5">
        <h3 class="mb-2">Please wait, generating export...</h3>
        <h4>It could take a few minutes.</h4>

        <h5 v-if="!processing">Exporting final ranking list...</h5>
        <h5 v-if="processing">Awaiting export to be processed by server...</h5>
      </div>
    </div>
  </div>
</template>

<script>
  import {ReportsService} from '@/services';
  import html2canvas from 'html2canvas';
  import swal from 'sweetalert2';

  export default {
    data() {
      return {
        loggedUser: {},
        exporting: false,
        processing: false
      }
    },
    props: ['filters'],
    created() {
      this.loggedUser = this.$store.getters['Auth/loggedUser'];
    },
    methods: {
      async doExport() {
        let vm = this;

        vm.exporting = true;
        let loader = vm.$loading.show();

        vm.processing = true;

        let response = await ReportsService.exportFinalRanking(vm.filters);

        vm.exporting = false;
        loader.hide();

        if (response.data.success === true) {
          let pdf_download = response.data.pdf_download;

          let html = 'Your evaluation report export is ready! <br/>' +
            'An email with export has been sent to: ' + vm.loggedUser.email + '<br/><br/>' +
            '<a class="btn btn-primary" target="_blank" href="' + pdf_download + '">Download Export</a>';

          await swal({
            title: this.$t('general.notification__success'),
            html: html,
            type: 'success',
            showConfirmButton: false
          });
        }
      }
    }
  }
</script>